module.exports = __webpack_public_path__ + "img/2.5f1287ea.jpg";